import * as React from 'react';
import { useZustand } from 'use-zustand';
import { widgetStore } from "../store";

function hasImages(images) {
  return Array.isArray(images) && images.length > 0;
}

function Thumbnail(props) {
  const {url, id, selected} = props.image || {};
  return (
    <div className='thumbnail' data-id={id} data-selected={selected}>
      <img src={url} loading='lazy' alt={`image-${id}`}/>
      {props.children}
    </div>
  );
}

function ImageControls(props) {
  const {onClickHandler} = props;

  return (
    <div className='thumbnail__controls'>
      <button type='button' onClick={onClickHandler}>Select</button>
    </div>
  );
}

export function DeveloperWallImages(props) {
  const images = useZustand(widgetStore, state => state.images);

  return (
    <div className='thumbnails'>
      {hasImages(images) && images.map(img => <Thumbnail key={img.id} image={img}></Thumbnail>)}
      {!hasImages(images) && (
        <div>There are no generated images.</div>
      )}
    </div>
  );
}

export function DeveloperWallImageEditor(props) {
  const images = useZustand(widgetStore, state => state.images);
  const updateSelectedImageURL = useZustand(widgetStore, state => state.updateSelectedImageURL);
  const updateSelectedImageID = useZustand(widgetStore, state => state.updateSelectedImageID);

  return (
    <div className='thumbnails'>
      {hasImages(images) && images.map(img => {
        return (
          <Thumbnail key={img.id} image={img}>
            <ImageControls onClickHandler={() => {
              updateSelectedImageURL(img.url);
              updateSelectedImageID(img.id)
            }}/>
          </Thumbnail>
        );
      })}
    </div>
  );
}
